import { format, isSameDay } from 'date-fns';
import { getLocale } from 'lib';
import { GOALRUSH_END_REASON, GOALRUSH_SESSION_STATUS } from '../constants';

// Shared by the Sessions list and its detail panel.

// Session status (+ end reason) → label key and Badge variant.
export const statusOf = (s) => {
  if (s.status === GOALRUSH_SESSION_STATUS.ACTIVE) return { key: 'running', variant: 'active' };
  if (s.status === GOALRUSH_SESSION_STATUS.PAUSED) return { key: 'paused', variant: 'muted' };
  if (s.endReason === GOALRUSH_END_REASON.TARGET_REACHED)
    return { key: 'completed', variant: 'info' };
  if (s.endReason === GOALRUSH_END_REASON.TARGET_NOT_REACHED)
    return { key: 'timeUp', variant: 'warning' };
  return { key: 'terminated', variant: 'danger' };
};

export const fmtTime = (value, pattern = 'MMM d, HH:mm') =>
  value ? format(new Date(value), pattern, { locale: getLocale() }) : '—';

// A span as its two largest units ("1h 5m", "3d 2h"); seconds only under a minute.
export const fmtLength = (ms) => {
  const sec = Math.max(0, Math.round(ms / 1000));
  if (sec < 60) return `${sec}s`;
  const parts = [
    [Math.floor(sec / 86400), 'd'],
    [Math.floor((sec % 86400) / 3600), 'h'],
    [Math.floor((sec % 3600) / 60), 'm']
  ];
  const first = parts.findIndex(([n]) => n > 0);
  return parts
    .slice(first, first + 2)
    .filter(([n]) => n > 0)
    .map(([n, unit]) => `${n}${unit}`)
    .join(' ');
};

// "Oct 29, 02:45 → 02:46": the end drops its date when it is the start's day.
export const fmtSpan = (start, end) => {
  if (!end) return fmtTime(start);
  const endText = isSameDay(new Date(start), new Date(end)) ? fmtTime(end, 'HH:mm') : fmtTime(end);
  return `${fmtTime(start)} → ${endText}`;
};
